module.exports = __webpack_public_path__ + "img/convenioSindical.17617eb0.jpg";